import angular from 'angular';
import DisconnectOffersItv from './disconnect.offers.itv.component';
import { routing } from './disconnect.offers.itv.config';
export default angular.module('invision.customercare.customer.disconnectoffersItv', []).component('disconnectOffersItv', DisconnectOffersItv).config(routing).name;